// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-list/orders-list.less
// module id = 3766
// module chunks = 0